






















import { Vue, Component, Prop } from "vue-property-decorator";
import CustomTable from "@/components/form/CustomTable.vue";
import LearningGroupTableItem from "@/components/learning-group/LearningGroupTableItem.vue";
import { Registration as IRegistration } from "@/api-v2/learning-group/models/registration";
import LearningGroupStudentTableItem from "@/components/learning-group/LearningGroupStudentTableItem.vue";

@Component({
  components: {
    LearningGroupStudentTableItem,
    LearningGroupTableItem,
    CustomTable
  }
})
export default class LearningGroupStudentTable extends Vue {
  @Prop() registrations!: IRegistration[];
  @Prop({ default: true }) allowToEdit!: boolean;
}
